import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_INTRO_TEMPLATE = [
  {
    icon: "ai",
    iconColor: "white",
    text: "Powered by GenAI",
    listItemCustomStyle: { width: "auto" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithMeter",
    iconColor: "white",
    text: "Accelerated \nnetwork rollout",
    listItemCustomStyle: { width: "auto" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "screenWithDollarSignAndGear",
    iconColor: "white",
    text: "Optimized total \ncost of ownership",
    listItemCustomStyle: { width: "auto" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_INTRO_INLCM = {
  title: "Infosys Network \nLifecycle Manager",
  text: "The maestro of multi-domain network; orchestrating \nyour network's end-to-end lifecycle with efficiency.",
  listData: LIST_DATA_INTRO_TEMPLATE,
  next: {
    label: "FIND OUT HOW",
    onClick: () => setCurrentPage("ENG_302"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_1"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_INTRO_01.jpg",
  rightSideImage: "ENG/INLCM/INLCM_Intro_cycle.png",
};
